//************* Used for Auth page ****************\\
const AUTH_FORGOT_PASSWORD_PATH = '/login/lostpassword';
const AUTH_FORM_SUBMIT_URL = '/ngx_security_check';

//************* Used for Activate User page ****************\\
const ACTIVATEUSER_FORM_SUBMIT_URL = '/login/doactivate';

//************* Used for Lost Password, Expired, Locked pages ****************\\
const LOSTPASSWORD_FORM_SUBMIT_URL = '/login/sendpassword';

//************* Used for Denied access page ****************\\
const DENIEDACCESS_REDIRECT_URL = '../login/auth';

//************* Used for recover Password page ****************\\
const RECOVERPASSWORD_FORM_SUBMIT_URL = '/login/dorecoverpassword';

//************* Used for reset Password page ****************\\
const RESETPASSWORD_FORM_SUBMIT_URL = '/login/doresetpassword';

//************* (Other) ****************\\
const pwdToggleTooltip =
  'Toggle password visibility. For security, we disable this action when using un-edited copy&paste text. To enable it, simply start typing.';

const SCREEN_CLASSES = 'content-login';
const SCREEN_CLASSES_WIDE = SCREEN_CLASSES + ' content-wide';

export default {
  AUTH_FORGOT_PASSWORD_PATH,
  AUTH_FORM_SUBMIT_URL,

  ACTIVATEUSER_FORM_SUBMIT_URL,

  LOSTPASSWORD_FORM_SUBMIT_URL,

  DENIEDACCESS_REDIRECT_URL,
  RECOVERPASSWORD_FORM_SUBMIT_URL,
  RESETPASSWORD_FORM_SUBMIT_URL,

  pwdToggleTooltip,

  SCREEN_CLASSES_WIDE,
  SCREEN_CLASSES,
};
